const LOAD_DATA_MASTER_CATEGORY           = 'LOAD_DATA_MASTER_CATEGORY'
const LOAD_DATA_MASTER_CATEGORY_SUCCESS   = 'LOAD_DATA_MASTER_CATEGORY_SUCCESS'
const LOAD_DATA_MASTER_CATEGORY_FAILED    = 'LOAD_DATA_MASTER_CATEGORY_FAILED'
const UNMOUNT_DATA_MASTER_CATEGORY        = 'UNMOUNT_DATA_MASTER_CATEGORY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const masterCategoryReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_CATEGORY:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_MASTER_CATEGORY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_MASTER_CATEGORY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_MASTER_CATEGORY:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default masterCategoryReducer;